import { LoginType } from 'model/operator';
import REGEXP from 'config/regexp';

export const operatorColumnConfig = [
  {
    name: 'operator_name',
    title: '成员姓名',
  },
  {
    name: 'operator_role',
    title: '平台角色',
  },
  {
    name: 'mobile',
    title: '手机号码',
  },
  {
    name: 'login_type',
    title: '登录账号',
  },
  {
    name: 'comment',
    title: '备注',
  },
];

export const formFieldConfig = {
  operator_name: {
    required: true,
    min: 2,
    max: 10,
  },
  operator_role: {
    required: true,
  },
  mobile: {
    required: true,
    patterns: [
      {
        pattern: REGEXP.mobile,
        message: '电话不合法',
      },
    ],
  },
  login_type: {
    required: true,
  },
  login_name: {
    required: true,
    rules: [
      (data: any) => {
        if (data.login_type === LoginType.qq && !REGEXP.number.test(data.login_name)) {
          return 'QQ号不合法';
        }
        return '';
      },
    ],
  },
  comment: {
    required: true,
    min: 2,
    max: 10,
  },
};
